/* eslint-disable jira/filename-case */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const pageSegmentLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.board-view', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

// measure list scroll performance
export const scrollPerformance: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.board-view.scroll-performance', {
			type: ExperienceTypes.Operation,
			performanceType: ExperiencePerformanceTypes.Custom,
		}),
	);
